// const county_code = {
//     "Abidjan": "CI",
//     "Accra": "GH",
//     "Adak": "US",
//     "Addis_Ababa": "ET",
//     "Adelaide": "AU",
//     "Aden": "YE",
//     "Algiers": "DZ",
//     "Almaty": "KZ",
//     "Amman": "JO",
//     "Amsterdam": "NL",
//     "Anadyr": "RU",
//     "Anchorage": "US",
//     "Andorra": "AD",
//     "Anguilla": "AI",
//     "Antananarivo": "MG",
//     "Antigua": "AG",
//     "Apia": "WS",
//     "Aqtau": "KZ",
//     "Aqtobe": "KZ",
//     "Araguaina": "BR",
//     "Argentina": "AR",
//     "Aruba": "AW",
//     "Ashgabat": "TM",
//     "Asmara": "ER",
//     "Astrakhan": "RU",
//     "Asuncion": "PY",
//     "Athens": "GR",
//     "Atikokan": "CA",
//     "Atyrau": "KZ",
//     "Auckland": "NZ",
//     "Azores": "PT",
//     "Baghdad": "IQ",
//     "Bahia": "BR",
//     "Bahia_Banderas": "MX",
//     "Bahrain": "BH",
//     "Baku": "AZ",
//     "Bamako": "ML",
//     "Bangkok": "TH",
//     "Bangui": "CF",
//     "Banjul": "GM",
//     "Barbados": "BB",
//     "Barnaul": "RU",
//     "Beirut": "LB",
//     "Belem": "BR",
//     "Belgrade": "RS",
//     "Belize": "BZ",
//     "Berlin": "DE",
//     "Bermuda": "BM",
//     "Bishkek": "KG",
//     "Bissau": "GW",
//     "Blanc-Sablon": "CA",
//     "Blantyre": "MW",
//     "Boa_Vista": "BR",
//     "Bogota": "CO",
//     "Boise": "US",
//     "Bougainville": "PG",
//     "Bratislava": "SK",
//     "Brazzaville": "CG",
//     "Brisbane": "AU",
//     "Broken_Hill": "AU",
//     "Brunei": "BN",
//     "Brussels": "BE",
//     "Bucharest": "RO",
//     "Budapest": "HU",
//     "Bujumbura": "BI",
//     "Busingen": "DE",
//     "Cairo": "EG",
//     "Cambridge_Bay": "CA",
//     "Campo_Grande": "BR",
//     "Canary": "ES",
//     "Cancun": "MX",
//     "Cape_Verde": "CV",
//     "Caracas": "VE",
//     "Casablanca": "MA",
//     "Casey": "AQ",
//     "Cayenne": "GF",
//     "Cayman": "KY",
//     "Ceuta": "ES",
//     "Chagos": "IO",
//     "Chatham": "NZ",
//     "Chicago": "US",
//     "Chihuahua": "MX",
//     "Chisinau": "MD",
//     "Chita": "RU",
//     "Christmas": "CX",
//     "Chuuk": "FM",
//     "Ciudad_Juarez": "MX",
//     "Cocos": "CC",
//     "Colombo": "LK",
//     "Comoro": "KM",
//     "Conakry": "GN",
//     "Copenhagen": "DK",
//     "Costa_Rica": "CR",
//     "Coyhaique": "CL",
//     "Creston": "CA",
//     "Cuiaba": "BR",
//     "Curacao": "CW",
//     "Dakar": "SN",
//     "Damascus": "SY",
//     "Danmarkshavn": "GL",
//     "Dar_es_Salaam": "TZ",
//     "Darwin": "AU",
//     "Davis": "AQ",
//     "Dawson": "CA",
//     "Dawson_Creek": "CA",
//     "Denver": "US",
//     "Detroit": "US",
//     "Dhaka": "BD",
//     "Dili": "TL",
//     "Djibouti": "DJ",
//     "Dominica": "DM",
//     "Douala": "CM",
//     "Dubai": "AE",
//     "Dublin": "IE",
//     "DumontDUrville": "AQ",
//     "Dushanbe": "TJ",
//     "Easter": "CL",
//     "Edmonton": "CA",
//     "Efate": "VU",
//     "Eirunepe": "BR",
//     "El_Aaiun": "MA",
//     "El_Salvador": "SV",
//     "Eucla": "AU",
//     "Fakaofo": "TK",
//     "Famagusta": "CY",
//     "Faroe": "FO",
//     "Fiji": "FJ",
//     "Fort_Nelson": "CA",
//     "Fortaleza": "BR",
//     "Freetown": "SL",
//     "Funafuti": "TV",
//     "Gaborone": "BW",
//     "Galapagos": "EC",
//     "Gambier": "PF",
//     "Gaza": "PS",
//     "Gibraltar": "GI",
//     "Glace_Bay": "CA",
//     "Goose_Bay": "CA",
//     "Grand_Turk": "TC",
//     "Grenada": "GD",
//     "Guadalcanal": "SB",
//     "Guadeloupe": "GP",
//     "Guam": "GU",
//     "Guatemala": "GT",
//     "Guayaquil": "EC",
//     "Guernsey": "GG",
//     "Guyana": "GY",
//     "Halifax": "CA",
//     "Harare": "ZW",
//     "Havana": "CU",
//     "Hebron": "PS",
//     "Helsinki": "FI",
//     "Hermosillo": "MX",
//     "Ho_Chi_Minh": "VN",
//     "Hobart": "AU",
//     "Hong_Kong": "HK",
//     "Honolulu": "US",
//     "Hovd": "MN",
//     "Indiana": "US",
//     "Inuvik": "CA",
//     "Iqaluit": "CA",
//     "Irkutsk": "RU",
//     "Isle_of_Man": "IM",
//     "Istanbul": "TR",
//     "Jakarta": "ID",
//     "Jamaica": "JM",
//     "Jayapura": "ID",
//     "Jersey": "JE",
//     "Jerusalem": "IL",
//     "Johannesburg": "ZA",
//     "Juba": "SS",
//     "Juneau": "US",
//     "Kabul": "AF",
//     "Kaliningrad": "RU",
//     "Kamchatka": "RU",
//     "Kampala": "UG",
//     "Kanton": "KI",
//     "Karachi": "PK",
//     "Kathmandu": "NP",
//     "Kentucky": "US",
//     "Kerguelen": "TF",
//     "Khandyga": "RU",
//     "Khartoum": "SD",
//     "Kigali": "RW",
//     "Kinshasa": "CD",
//     "Kiritimati": "KI",
//     "Kirov": "RU",
//     "Calcutta": "IN",
//     "Kolkata":"IN",
//     "Kosrae": "FM",
//     "Kralendijk": "BQ",
//     "Krasnoyarsk": "RU",
//     "Kuala_Lumpur": "MY",
//     "Kuching": "MY",
//     "Kuwait": "KW",
//     "Kwajalein": "MH",
//     "Kyiv": "UA",
//     "La_Paz": "BO",
//     "Lagos": "NG",
//     "Libreville": "GA",
//     "Lima": "PE",
//     "Lindeman": "AU",
//     "Lisbon": "PT",
//     "Ljubljana": "SI",
//     "Lome": "TG",
//     "London": "GB",
//     "Longyearbyen": "SJ",
//     "Lord_Howe": "AU",
//     "Los_Angeles": "US",
//     "Lower_Princes": "SX",
//     "Luanda": "AO",
//     "Lubumbashi": "CD",
//     "Lusaka": "ZM",
//     "Luxembourg": "LU",
//     "Macau": "MO",
//     "Maceio": "BR",
//     "Macquarie": "AU",
//     "Madeira": "PT",
//     "Madrid": "ES",
//     "Magadan": "RU",
//     "Mahe": "SC",
//     "Majuro": "MH",
//     "Makassar": "ID",
//     "Malabo": "GQ",
//     "Maldives": "MV",
//     "Malta": "MT",
//     "Managua": "NI",
//     "Manaus": "BR",
//     "Manila": "PH",
//     "Maputo": "MZ",
//     "Mariehamn": "AX",
//     "Marigot": "MF",
//     "Marquesas": "PF",
//     "Martinique": "MQ",
//     "Maseru": "LS",
//     "Matamoros": "MX",
//     "Mauritius": "MU",
//     "Mawson": "AQ",
//     "Mayotte": "YT",
//     "Mazatlan": "MX",
//     "Mbabane": "SZ",
//     "McMurdo": "AQ",
//     "Melbourne": "AU",
//     "Menominee": "US",
//     "Merida": "MX",
//     "Metlakatla": "US",
//     "Mexico_City": "MX",
//     "Midway": "UM",
//     "Minsk": "BY",
//     "Miquelon": "PM",
//     "Mogadishu": "SO",
//     "Monaco": "MC",
//     "Moncton": "CA",
//     "Monrovia": "LR",
//     "Monterrey": "MX",
//     "Montevideo": "UY",
//     "Montserrat": "MS",
//     "Moscow": "RU",
//     "Muscat": "OM",
//     "Nairobi": "KE",
//     "Nassau": "BS",
//     "Nauru": "NR",
//     "Ndjamena": "TD",
//     "New_York": "US",
//     "Niamey": "NE",
//     "Nicosia": "CY",
//     "Niue": "NU",
//     "Nome": "US",
//     "Norfolk": "NF",
//     "Noronha": "BR",
//     "North_Dakota": "US",
//     "Nouakchott": "MR",
//     "Noumea": "NC",
//     "Novokuznetsk": "RU",
//     "Novosibirsk": "RU",
//     "Nuuk": "GL",
//     "Ojinaga": "MX",
//     "Omsk": "RU",
//     "Oral": "KZ",
//     "Oslo": "NO",
//     "Ouagadougou": "BF",
//     "Pago_Pago": "AS",
//     "Palau": "PW",
//     "Palmer": "AQ",
//     "Panama": "PA",
//     "Paramaribo": "SR",
//     "Paris": "FR",
//     "Perth": "AU",
//     "Phnom_Penh": "KH",
//     "Phoenix": "US",
//     "Pitcairn": "PN",
//     "Podgorica": "ME",
//     "Pohnpei": "FM",
//     "Pontianak": "ID",
//     "Port_Moresby": "PG",
//     "Port_of_Spain": "TT",
//     "Port-au-Prince": "HT",
//     "Porto_Velho": "BR",
//     "Porto-Novo": "BJ",
//     "Prague": "CZ",
//     "Puerto_Rico": "PR",
//     "Punta_Arenas": "CL",
//     "Pyongyang": "KP",
//     "Qatar": "QA",
//     "Qostanay": "KZ",
//     "Qyzylorda": "KZ",
//     "Rankin_Inlet": "CA",
//     "Rarotonga": "CK",
//     "Recife": "BR",
//     "Regina": "CA",
//     "Resolute": "CA",
//     "Reunion": "RE",
//     "Reykjavik": "IS",
//     "Riga": "LV",
//     "Rio_Branco": "BR",
//     "Riyadh": "SA",
//     "Rome": "IT",
//     "Rothera": "AQ",
//     "Saipan": "MP",
//     "Sakhalin": "RU",
//     "Samara": "RU",
//     "Samarkand": "UZ",
//     "San_Marino": "SM",
//     "Santarem": "BR",
//     "Santiago": "CL",
//     "Santo_Domingo": "DO",
//     "Sao_Paulo": "BR",
//     "Sao_Tome": "ST",
//     "Sarajevo": "BA",
//     "Saratov": "RU",
//     "Scoresbysund": "GL",
//     "Seoul": "KR",
//     "Shanghai": "CN",
//     "Simferopol": "UA",
//     "Singapore": "SG",
//     "Sitka": "US",
//     "Skopje": "MK",
//     "Sofia": "BG",
//     "South_Georgia": "GS",
//     "Srednekolymsk": "RU",
//     "St_Barthelemy": "BL",
//     "St_Helena": "SH",
//     "St_Johns": "CA",
//     "St_Kitts": "KN",
//     "St_Lucia": "LC",
//     "St_Thomas": "VI",
//     "St_Vincent": "VC",
//     "Stanley": "FK",
//     "Stockholm": "SE",
//     "Swift_Current": "CA",
//     "Sydney": "AU",
//     "Syowa": "AQ",
//     "Tahiti": "PF",
//     "Taipei": "TW",
//     "Tallinn": "EE",
//     "Tarawa": "KI",
//     "Tashkent": "UZ",
//     "Tbilisi": "GE",
//     "Tegucigalpa": "HN",
//     "Tehran": "IR",
//     "Thimphu": "BT",
//     "Thule": "GL",
//     "Tijuana": "MX",
//     "Tirane": "AL",
//     "Tokyo": "JP",
//     "Tomsk": "RU",
//     "Tongatapu": "TO",
//     "Toronto": "CA",
//     "Tortola": "VG",
//     "Tripoli": "LY",
//     "Troll": "AQ",
//     "Tunis": "TN",
//     "Ulaanbaatar": "MN",
//     "Ulyanovsk": "RU",
//     "Urumqi": "CN",
//     "Ust-Nera": "RU",
//     "Vaduz": "LI",
//     "Vancouver": "CA",
//     "Vatican": "VA",
//     "Vienna": "AT",
//     "Vientiane": "LA",
//     "Vilnius": "LT",
//     "Vladivostok": "RU",
//     "Volgograd": "RU",
//     "Vostok": "AQ",
//     "Wake": "UM",
//     "Wallis": "WF",
//     "Warsaw": "PL",
//     "Whitehorse": "CA",
//     "Windhoek": "NA",
//     "Winnipeg": "CA",
//     "Yakutat": "US",
//     "Yakutsk": "RU",
//     "Yangon": "MM",
//     "Yekaterinburg": "RU",
//     "Yerevan": "AM",
//     "Zagreb": "HR",
//     "Zurich": "CH"
// }

import config from "src/config/config";

// const county_name = {
//     "Abidjan": "Côte d'Ivoire",
//     "Accra": "Ghana",
//     "Adak": "United States",
//     "Addis_Ababa": "Ethiopia",
//     "Adelaide": "Australia",
//     "Aden": "Yemen",
//     "Algiers": "Algeria",
//     "Almaty": "Kazakhstan",
//     "Amman": "Jordan",
//     "Amsterdam": "Netherlands",
//     "Anadyr": "Russian Federation",
//     "Anchorage": "United States",
//     "Andorra": "Andorra",
//     "Anguilla": "Anguilla",
//     "Antananarivo": "Madagascar",
//     "Antigua": "Antigua and Barbuda",
//     "Apia": "Samoa",
//     "Aqtau": "Kazakhstan",
//     "Aqtobe": "Kazakhstan",
//     "Araguaina": "Brazil",
//     "Argentina": "Argentina",
//     "Aruba": "Aruba",
//     "Ashgabat": "Turkmenistan",
//     "Asmara": "Eritrea",
//     "Astrakhan": "Russian Federation",
//     "Asuncion": "Paraguay",
//     "Athens": "Greece",
//     "Atikokan": "Canada",
//     "Atyrau": "Kazakhstan",
//     "Auckland": "New Zealand",
//     "Azores": "Portugal",
//     "Baghdad": "Iraq",
//     "Bahia": "Brazil",
//     "Bahia_Banderas": "Mexico",
//     "Bahrain": "Bahrain",
//     "Baku": "Azerbaijan",
//     "Bamako": "Mali",
//     "Bangkok": "Thailand",
//     "Bangui": "Central African Republic",
//     "Banjul": "Gambia",
//     "Barbados": "Barbados",
//     "Barnaul": "Russian Federation",
//     "Beirut": "Lebanon",
//     "Belem": "Brazil",
//     "Belgrade": "Serbia",
//     "Belize": "Belize",
//     "Berlin": "Germany",
//     "Bermuda": "Bermuda",
//     "Bishkek": "Kyrgyzstan",
//     "Bissau": "Guinea-Bissau",
//     "Blanc-Sablon": "Canada",
//     "Blantyre": "Malawi",
//     "Boa_Vista": "Brazil",
//     "Bogota": "Colombia",
//     "Boise": "United States",
//     "Bougainville": "Papua New Guinea",
//     "Bratislava": "Slovakia",
//     "Brazzaville": "Congo",
//     "Brisbane": "Australia",
//     "Broken_Hill": "Australia",
//     "Brunei": "Brunei Darussalam",
//     "Brussels": "Belgium",
//     "Bucharest": "Romania",
//     "Budapest": "Hungary",
//     "Bujumbura": "Burundi",
//     "Busingen": "Germany",
//     "Cairo": "Egypt",
//     "Cambridge_Bay": "Canada",
//     "Campo_Grande": "Brazil",
//     "Canary": "Spain",
//     "Cancun": "Mexico",
//     "Cape_Verde": "Cape Verde",
//     "Caracas": "Venezuela, Bolivarian Republic of",
//     "Casablanca": "Morocco",
//     "Casey": "Antarctica",
//     "Cayenne": "French Guiana",
//     "Cayman": "Cayman Islands",
//     "Ceuta": "Spain",
//     "Chagos": "British Indian Ocean Territory",
//     "Chatham": "New Zealand",
//     "Chicago": "United States",
//     "Chihuahua": "Mexico",
//     "Chisinau": "Moldova, Republic of",
//     "Chita": "Russian Federation",
//     "Christmas": "Christmas Island",
//     "Chuuk": "Micronesia, Federated States of",
//     "Ciudad_Juarez": "Mexico",
//     "Cocos": "Cocos (Keeling) Islands",
//     "Colombo": "Sri Lanka",
//     "Comoro": "Comoros",
//     "Conakry": "Guinea",
//     "Copenhagen": "Denmark",
//     "Costa_Rica": "Costa Rica",
//     "Coyhaique": "Chile",
//     "Creston": "Canada",
//     "Cuiaba": "Brazil",
//     "Curacao": "Curaçao",
//     "Dakar": "Senegal",
//     "Damascus": "Syrian Arab Republic",
//     "Danmarkshavn": "Greenland",
//     "Dar_es_Salaam": "Tanzania, United Republic of",
//     "Darwin": "Australia",
//     "Davis": "Antarctica",
//     "Dawson": "Canada",
//     "Dawson_Creek": "Canada",
//     "Denver": "United States",
//     "Detroit": "United States",
//     "Dhaka": "Bangladesh",
//     "Dili": "Timor-Leste",
//     "Djibouti": "Djibouti",
//     "Dominica": "Dominica",
//     "Douala": "Cameroon",
//     "Dubai": "United Arab Emirates",
//     "Dublin": "Ireland",
//     "DumontDUrville": "Antarctica",
//     "Dushanbe": "Tajikistan",
//     "Easter": "Chile",
//     "Edmonton": "Canada",
//     "Efate": "Vanuatu",
//     "Eirunepe": "Brazil",
//     "El_Aaiun": "Morocco",
//     "El_Salvador": "El Salvador",
//     "Eucla": "Australia",
//     "Fakaofo": "Tokelau",
//     "Famagusta": "Cyprus",
//     "Faroe": "Faroe Islands",
//     "Fiji": "Fiji",
//     "Fort_Nelson": "Canada",
//     "Fortaleza": "Brazil",
//     "Freetown": "Sierra Leone",
//     "Funafuti": "Tuvalu",
//     "Gaborone": "Botswana",
//     "Galapagos": "Ecuador",
//     "Gambier": "French Polynesia",
//     "Gaza": "Palestine, State of",
//     "Gibraltar": "Gibraltar",
//     "Glace_Bay": "Canada",
//     "Goose_Bay": "Canada",
//     "Grand_Turk": "Turks and Caicos Islands",
//     "Grenada": "Grenada",
//     "Guadalcanal": "Solomon Islands",
//     "Guadeloupe": "Guadeloupe",
//     "Guam": "Guam",
//     "Guatemala": "Guatemala",
//     "Guayaquil": "Ecuador",
//     "Guernsey": "Guernsey",
//     "Guyana": "Guyana",
//     "Halifax": "Canada",
//     "Harare": "Zimbabwe",
//     "Havana": "Cuba",
//     "Hebron": "Palestine, State of",
//     "Helsinki": "Finland",
//     "Hermosillo": "Mexico",
//     "Ho_Chi_Minh": "Viet Nam",
//     "Hobart": "Australia",
//     "Hong_Kong": "Hong Kong",
//     "Honolulu": "United States",
//     "Hovd": "Mongolia",
//     "Indiana": "United States",
//     "Inuvik": "Canada",
//     "Iqaluit": "Canada",
//     "Irkutsk": "Russian Federation",
//     "Isle_of_Man": "Isle of Man",
//     "Istanbul": "Turkey",
//     "Jakarta": "Indonesia",
//     "Jamaica": "Jamaica",
//     "Jayapura": "Indonesia",
//     "Jersey": "Jersey",
//     "Jerusalem": "Israel",
//     "Johannesburg": "South Africa",
//     "Juba": "South Sudan",
//     "Juneau": "United States",
//     "Kabul": "Afghanistan",
//     "Kaliningrad": "Russian Federation",
//     "Kamchatka": "Russian Federation",
//     "Kampala": "Uganda",
//     "Kanton": "Kiribati",
//     "Karachi": "Pakistan",
//     "Kathmandu": "Nepal",
//     "Kentucky": "United States",
//     "Kerguelen": "French Southern Territories",
//     "Khandyga": "Russian Federation",
//     "Khartoum": "Sudan",
//     "Kigali": "Rwanda",
//     "Kinshasa": "Congo, the Democratic Republic of the",
//     "Kiritimati": "Kiribati",
//     "Kirov": "Russian Federation",
//     "Calcutta": "India",
//     "Kolkata": "India",
//     "Kosrae": "Micronesia, Federated States of",
//     "Kralendijk": "Bonaire, Sint Eustatius and Saba",
//     "Krasnoyarsk": "Russian Federation",
//     "Kuala_Lumpur": "Malaysia",
//     "Kuching": "Malaysia",
//     "Kuwait": "Kuwait",
//     "Kwajalein": "Marshall Islands",
//     "Kyiv": "Ukraine",
//     "La_Paz": "Bolivia, Plurinational State of",
//     "Lagos": "Nigeria",
//     "Libreville": "Gabon",
//     "Lima": "Peru",
//     "Lindeman": "Australia",
//     "Lisbon": "Portugal",
//     "Ljubljana": "Slovenia",
//     "Lome": "Togo",
//     "London": "United Kingdom",
//     "Longyearbyen": "Svalbard and Jan Mayen",
//     "Lord_Howe": "Australia",
//     "Los_Angeles": "United States",
//     "Lower_Princes": "Sint Maarten (Dutch part)",
//     "Luanda": "Angola",
//     "Lubumbashi": "Congo, the Democratic Republic of the",
//     "Lusaka": "Zambia",
//     "Luxembourg": "Luxembourg",
//     "Macau": "Macao",
//     "Maceio": "Brazil",
//     "Macquarie": "Australia",
//     "Madeira": "Portugal",
//     "Madrid": "Spain",
//     "Magadan": "Russian Federation",
//     "Mahe": "Seychelles",
//     "Majuro": "Marshall Islands",
//     "Makassar": "Indonesia",
//     "Malabo": "Equatorial Guinea",
//     "Maldives": "Maldives",
//     "Malta": "Malta",
//     "Managua": "Nicaragua",
//     "Manaus": "Brazil",
//     "Manila": "Philippines",
//     "Maputo": "Mozambique",
//     "Mariehamn": "Åland Islands",
//     "Marigot": "Saint Martin (French part)",
//     "Marquesas": "French Polynesia",
//     "Martinique": "Martinique",
//     "Maseru": "Lesotho",
//     "Matamoros": "Mexico",
//     "Mauritius": "Mauritius",
//     "Mawson": "Antarctica",
//     "Mayotte": "Mayotte",
//     "Mazatlan": "Mexico",
//     "Mbabane": "Swaziland",
//     "McMurdo": "Antarctica",
//     "Melbourne": "Australia",
//     "Menominee": "United States",
//     "Merida": "Mexico",
//     "Metlakatla": "United States",
//     "Mexico_City": "Mexico",
//     "Midway": "United States Minor Outlying Islands",
//     "Minsk": "Belarus",
//     "Miquelon": "Saint Pierre and Miquelon",
//     "Mogadishu": "Somalia",
//     "Monaco": "Monaco",
//     "Moncton": "Canada",
//     "Monrovia": "Liberia",
//     "Monterrey": "Mexico",
//     "Montevideo": "Uruguay",
//     "Montserrat": "Montserrat",
//     "Moscow": "Russian Federation",
//     "Muscat": "Oman",
//     "Nairobi": "Kenya",
//     "Nassau": "Bahamas",
//     "Nauru": "Nauru",
//     "Ndjamena": "Chad",
//     "New_York": "United States",
//     "Niamey": "Niger",
//     "Nicosia": "Cyprus",
//     "Niue": "Niue",
//     "Nome": "United States",
//     "Norfolk": "Norfolk Island",
//     "Noronha": "Brazil",
//     "North_Dakota": "United States",
//     "Nouakchott": "Mauritania",
//     "Noumea": "New Caledonia",
//     "Novokuznetsk": "Russian Federation",
//     "Novosibirsk": "Russian Federation",
//     "Nuuk": "Greenland",
//     "Ojinaga": "Mexico",
//     "Omsk": "Russian Federation",
//     "Oral": "Kazakhstan",
//     "Oslo": "Norway",
//     "Ouagadougou": "Burkina Faso",
//     "Pago_Pago": "American Samoa",
//     "Palau": "Palau",
//     "Palmer": "Antarctica",
//     "Panama": "Panama",
//     "Paramaribo": "Suriname",
//     "Paris": "France",
//     "Perth": "Australia",
//     "Phnom_Penh": "Cambodia",
//     "Phoenix": "United States",
//     "Pitcairn": "Pitcairn",
//     "Podgorica": "Montenegro",
//     "Pohnpei": "Micronesia, Federated States of",
//     "Pontianak": "Indonesia",
//     "Port_Moresby": "Papua New Guinea",
//     "Port_of_Spain": "Trinidad and Tobago",
//     "Port-au-Prince": "Haiti",
//     "Porto_Velho": "Brazil",
//     "Porto-Novo": "Benin",
//     "Prague": "Czech Republic",
//     "Puerto_Rico": "Puerto Rico",
//     "Punta_Arenas": "Chile",
//     "Pyongyang": "Korea, Democratic People's Republic of",
//     "Qatar": "Qatar",
//     "Qostanay": "Kazakhstan",
//     "Qyzylorda": "Kazakhstan",
//     "Rankin_Inlet": "Canada",
//     "Rarotonga": "Cook Islands",
//     "Recife": "Brazil",
//     "Regina": "Canada",
//     "Resolute": "Canada",
//     "Reunion": "Réunion",
//     "Reykjavik": "Iceland",
//     "Riga": "Latvia",
//     "Rio_Branco": "Brazil",
//     "Riyadh": "Saudi Arabia",
//     "Rome": "Italy",
//     "Rothera": "Antarctica",
//     "Saipan": "Northern Mariana Islands",
//     "Sakhalin": "Russian Federation",
//     "Samara": "Russian Federation",
//     "Samarkand": "Uzbekistan",
//     "San_Marino": "San Marino",
//     "Santarem": "Brazil",
//     "Santiago": "Chile",
//     "Santo_Domingo": "Dominican Republic",
//     "Sao_Paulo": "Brazil",
//     "Sao_Tome": "Sao Tome and Principe",
//     "Sarajevo": "Bosnia and Herzegovina",
//     "Saratov": "Russian Federation",
//     "Scoresbysund": "Greenland",
//     "Seoul": "Korea, Republic of",
//     "Shanghai": "China",
//     "Simferopol": "Ukraine",
//     "Singapore": "Singapore",
//     "Sitka": "United States",
//     "Skopje": "Macedonia, the Former Yugoslav Republic of",
//     "Sofia": "Bulgaria",
//     "South_Georgia": "South Georgia and the South Sandwich Islands",
//     "Srednekolymsk": "Russian Federation",
//     "St_Barthelemy": "Saint Barthélemy",
//     "St_Helena": "Saint Helena, Ascension and Tristan da Cunha",
//     "St_Johns": "Canada",
//     "St_Kitts": "Saint Kitts and Nevis",
//     "St_Lucia": "Saint Lucia",
//     "St_Thomas": "Virgin Islands, U.S.",
//     "St_Vincent": "Saint Vincent and the Grenadines",
//     "Stanley": "Falkland Islands (Malvinas)",
//     "Stockholm": "Sweden",
//     "Swift_Current": "Canada",
//     "Sydney": "Australia",
//     "Syowa": "Antarctica",
//     "Tahiti": "French Polynesia",
//     "Taipei": "Taiwan, Province of China",
//     "Tallinn": "Estonia",
//     "Tarawa": "Kiribati",
//     "Tashkent": "Uzbekistan",
//     "Tbilisi": "Georgia",
//     "Tegucigalpa": "Honduras",
//     "Tehran": "Iran, Islamic Republic of",
//     "Thimphu": "Bhutan",
//     "Thule": "Greenland",
//     "Tijuana": "Mexico",
//     "Tirane": "Albania",
//     "Tokyo": "Japan",
//     "Tomsk": "Russian Federation",
//     "Tongatapu": "Tonga",
//     "Toronto": "Canada",
//     "Tortola": "Virgin Islands, British",
//     "Tripoli": "Libya",
//     "Troll": "Antarctica",
//     "Tunis": "Tunisia",
//     "Ulaanbaatar": "Mongolia",
//     "Ulyanovsk": "Russian Federation",
//     "Urumqi": "China",
//     "Ust-Nera": "Russian Federation",
//     "Vaduz": "Liechtenstein",
//     "Vancouver": "Canada",
//     "Vatican": "Holy See (Vatican City State)",
//     "Vienna": "Austria",
//     "Vientiane": "Lao People's Democratic Republic",
//     "Vilnius": "Lithuania",
//     "Vladivostok": "Russian Federation",
//     "Volgograd": "Russian Federation",
//     "Vostok": "Antarctica",
//     "Wake": "United States Minor Outlying Islands",
//     "Wallis": "Wallis and Futuna",
//     "Warsaw": "Poland",
//     "Whitehorse": "Canada",
//     "Windhoek": "Namibia",
//     "Winnipeg": "Canada",
//     "Yakutat": "United States",
//     "Yakutsk": "Russian Federation",
//     "Yangon": "Myanmar",
//     "Yekaterinburg": "Russian Federation",
//     "Yerevan": "Armenia",
//     "Zagreb": "Croatia",
//     "Zurich": "Switzerland"
// }

// const getTimeZone = () => {
//     try {
//         let retObj = null;
//         if (typeof Intl === 'object' && Intl.DateTimeFormat) {
//             const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
//             if (timezone === "" || !timezone) {
//                 return null;
//             }
//             const state = timezone.split("/")[1];
//             const countryCode = county_code[state];
//             const countryName = county_name[state];

//             retObj = {
//                 countryCode,
//                 countryName
//             }

//             return retObj;
//         }
//         return retObj;

//     } catch (error) {
//         console.log('Time Zone is not supported in your browser');
//         return null
//     }
// }

const getRestrictedZone = async () => {
    const API = config.restrictedZoneAPI;
    return fetch(`${API}/country-block-website`)
        .then(res => res.json())
        .then(res => res)
        .catch(error => console.log(`Error in Restricted API: ${error.message}`))
}

export default getRestrictedZone;